<template>
  <div id="Modal">
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="openModal"
      ref="vuemodal"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header p-0">
            <button
              type="button"
              class="close mt-1 mr-1"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" style="font-size: 20px">&times;</span>
            </button>
          </div>

          <div
            class="modal-body"
            v-if="this.$store.state.ComponentInToModal.Frm == 'AddDefineShobe'"
          >
            <modal-add-new-shobe></modal-add-new-shobe>
          </div>
          <div
            class="modal-body"
            v-if="this.$store.state.ComponentInToModal.Frm == 'EditShobe'"
          >
            <modal-edit-shobe
              v-if="this.$store.state.renderComponent"
            ></modal-edit-shobe>
          </div>
          <div
            class="modal-body"
            v-if="
              this.$store.state.ComponentInToModal.Frm == 'AddDefineInfoSystem'
            "
          >
            <modal-add-define-info-system></modal-add-define-info-system>
          </div>
          <div
            class="modal-body"
            v-if="this.$store.state.ComponentInToModal.Frm == 'EditInfoSys'"
          >
            <modal-edit-define-info-system
              v-if="this.$store.state.renderComponent"
            ></modal-edit-define-info-system>
          </div>
          <div
            class="modal-body"
            v-if="
              this.$store.state.ComponentInToModal.Frm == 'AddTarifKarbaran'
            "
          >
            <modal-add-tarif-karbaran></modal-add-tarif-karbaran>
          </div>
          <div
            class="modal-body"
            v-if="this.$store.state.ComponentInToModal.Frm == 'EditKarbaran'"
          >
            <modal-edit-tarif-karbaran
              v-if="this.$store.state.renderComponent"
            ></modal-edit-tarif-karbaran>
          </div>
          <div
            class="modal-body"
            v-if="this.$store.state.ComponentInToModal.Frm == 'AlignColumns'"
          >
            <modal-grid-columns
              v-if="this.$store.state.renderComponent"
            ></modal-grid-columns>
          </div>
          <div
            class="modal-body"
            v-if="this.$store.state.ComponentInToModal.Frm == 'AddTarifSematha'"
          >
            <modal-add-new-tarif-sematha
              v-if="this.$store.state.renderComponent"
            ></modal-add-new-tarif-sematha>
          </div>
          <div
            class="modal-body"
            v-if="
              this.$store.state.ComponentInToModal.Frm == 'EditTarifSematha'
            "
          >
            <modal-edit-tarif-sematha
              v-if="this.$store.state.renderComponent"
            ></modal-edit-tarif-sematha>
          </div>
          <div
            class="modal-body"
            v-if="
              this.$store.state.ComponentInToModal.Frm == 'DetailLogInformation'
            "
          >
            <detail-log-information
              v-if="this.$store.state.renderComponent"
            ></detail-log-information>
          </div>
          <div
            class="modal-body"
            v-if="this.$store.state.ComponentInToModal.Frm == 'Information'"
          >
            <modal-information
              v-if="this.$store.state.renderComponent"
            ></modal-information>
          </div>
          <div
            class="modal-body"
            v-else-if="this.$store.state.ComponentInToModal.Frm == ''"
          ></div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
  </div>
</template>
<script>
import ModalAddDefineInfoSystem from "../CmpInformationSystems/ModalAddDefineInfoSystem.vue";
import ModalEditDefineInfoSystem from "../CmpInformationSystems/ModalEditDefineInfoSystem.vue";
import ModalAddNewShobe from "../CmpShobe/ModalAddNewShobe";
import ModalEditShobe from "../CmpShobe/ModalEditShobe.vue";
import ModalAddTarifKarbaran from "../CmpTarifKarbaran/ModalAddTarifKarbaran.vue";
import ModalEditTarifKarbaran from "../CmpTarifKarbaran/ModalEditTarifKarbaran.vue";
import ModalAddNewTarifSematha from "../CmpTarifSematha/ModalAddNewTarifSematha.vue";
import ModalEditTarifSematha from "../CmpTarifSematha/ModalEditTarifSematha.vue";
import ModalGridColumns from "../Tools/ModalGridColumns.vue";
import DetailLogInformation from "../CmbUserLogInformation/DetailLogInformation.vue";
import ModalInformation from "./ModalInformation.vue";
export default {
  components: {
    ModalAddNewShobe,
    ModalEditShobe,
    ModalAddDefineInfoSystem,
    ModalEditDefineInfoSystem,
    ModalAddTarifKarbaran,
    ModalEditTarifKarbaran,
    ModalGridColumns,
    ModalAddNewTarifSematha,
    ModalEditTarifSematha,
    DetailLogInformation,
    ModalInformation,
  },
  data() {
    return {};
  },
  methods: {},
  computed: {},
  mounted() {},
};
</script>
<style scoped>
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 700px;
  }
}
.modal-header {
  border-bottom: none;
}
.modal {
  margin-top: 2%;
}
</style>
